import { render, staticRenderFns } from "./escalated-alert-card.vue?vue&type=template&id=d49dfb40&"
import script from "./escalated-alert-card.vue?vue&type=script&lang=ts&"
export * from "./escalated-alert-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports